import React from "react";
import type {VoidFunctionComponent} from "react";
import {useFilterDifficultyControlsLogic} from "./FilterDifficultyControls.logic";
import {
  SelectAndResetFilterControls
} from "../../../components/songs/songs-filters/select-and-reset-filter-controls/SelectAndResetFilterControls";

export const FilterDifficultyControls: VoidFunctionComponent = () => {
  const {handleResetOnClick} = useFilterDifficultyControlsLogic();
  return <SelectAndResetFilterControls onReset={handleResetOnClick} customLabel={`Reset difficulty filters`} ariaLabel={`Reset the difficulty level filters to show all`} />;
}
